import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  topicSelectorLabel: {
    id: 'topicSelectorLabel',
    defaultMessage: 'Learn more about each benefit',
  },
  detailAverageLabel: {
    id: 'detail.detailAverageLabel',
    defaultMessage: 'Average',
  },
  detailDevExecLabel: {
    id: 'detail.detailDevExecLabel',
    defaultMessage: 'Dev Exec',
  },
  detailDevLabel: {
    id: 'detail.detailDevLabel',
    defaultMessage: 'Dev',
  },
  detailIt: {
    id: 'detail.detailIt',
    defaultMessage: 'IT',
  },
  topicOverviewLabel: {
    id: 'topic.topicOverviewLabel',
    defaultMessage: 'Overview',
  },
  topic1NavTitle: {
    id: 'topic.topic1NavTitle',
    defaultMessage: 'Affordability',
  },
  topic2NavTitle: {
    id: 'topic.topic2NavTitle',
    defaultMessage: 'App quality',
  },
  topic3NavTitle: {
    id: 'topic.topic3NavTitle',
    defaultMessage: 'Flexibility',
  },
  topic4NavTitle: {
    id: 'topic.topic4NavTitle',
    defaultMessage: 'Security',
  },
  topic5NavTitle: {
    id: 'topic.topic5NavTitle',
    defaultMessage: 'App deployment',
  },
  topic6NavTitle: {
    id: 'topic.topic6NavTitle',
    defaultMessage: 'Productivity',
  },
  topic7NavTitle: {
    id: 'topic.topic7NavTitle',
    defaultMessage: 'Time-to-market',
  },
  topic8NavTitle: {
    id: 'topic.topic8NavTitle',
    defaultMessage: 'User experience',
  },
  topic9NavTitle: {
    id: 'topic.topic9NavTitle',
    defaultMessage: 'Operational management',
  },
  topicOverviewTitle: {
    id: 'topic.topicOverviewTitle',
    defaultMessage: 'See what users are saying about serverless architecture.',
  },
  topicOverviewSubTitle: {
    id: 'topic.topicOverviewSubTitle',
    defaultMessage:
      'Survey results show the average percent of users that rate each benefit as the most important for their teams.',
  },
  topic0Title: {
    id: 'topic.topic0Title',
    defaultMessage: 'Serverless architecture reduces development costs.',
  },
  topic0SubTitle: {
    id: 'topic.topic0SubTitle',
    defaultMessage:
      'On average, 36% of users report lower expenses as one of the top five benefits of going serverless.',
  },
  topic1Title: {
    id: 'topic.topic1Title',
    defaultMessage: 'Serverless architecture boosts app quality',
  },
  topic1SubTitle: {
    id: 'topic.topic1SubTitle',
    defaultMessage:
      'On average, 34% of users report better app performance as one of the top five benefits of going serverless.',
  },
  topic2Title: {
    id: 'topic.topic2Title',
    defaultMessage:
      'Serverless architecture leads to more flexible resourcing.',
  },
  topic2SubTitle: {
    id: 'topic.topic2SubTitle',
    defaultMessage:
      'On average, 33% of users report easier resource scaling as one of the top five benefits of going serverless.',
  },
  topic3Title: {
    id: 'topic.topic3Title',
    defaultMessage: 'Serverless architecture improves data security.',
  },
  topic3SubTitle: {
    id: 'topic.topic3SubTitle',
    defaultMessage:
      'On average, 30% of users report stronger data security as one of the top five benefits of going serverless.',
  },
  topic4Title: {
    id: 'topic.topic4Title',
    defaultMessage: 'Serverless architecture accelerates app deployment.',
  },
  topic4SubTitle: {
    id: 'topic.topic4SubTitle',
    defaultMessage:
      'On average, 30% of users report stronger data security as one of the top five benefits of going serverless.',
  },
  topic5Title: {
    id: 'topic.topic5Title',
    defaultMessage: 'Serverless architecture raises employee productivity.',
  },
  topic5SubTitle: {
    id: 'topic.topic5SubTitle',
    defaultMessage:
      'On average, 29% of users report increased productivity as one of the top five benefits of going serverless.',
  },
  topic6Title: {
    id: 'topic.topic6Title',
    defaultMessage: 'Serverless architecture creates faster time-to-market.',
  },
  topic6SubTitle: {
    id: 'topic.topic6SubTitle',
    defaultMessage:
      'On average, 28% of users report quick time-to-market responses as one of the top five benefits of going serverless.',
  },
  topic7Title: {
    id: 'topic.topic7Title',
    defaultMessage: 'Serverless architecture enhances user experience.',
  },
  topic7SubTitle: {
    id: 'topic.topic7SubTitle',
    defaultMessage:
      'On average, 28% of users report better UX interfaces as one of the top five benefits of going serverless.',
  },
  topic8Title: {
    id: 'topic.topic8Title',
    defaultMessage:
      'Serverless architecture streamlines operational management.',
  },
  topic8SubTitle: {
    id: 'topic.topic8SubTitle',
    defaultMessage:
      'On average, 27% of users report easier operational management as one of the top five benefits of going serverless.',
  },
  charts0Title: {
    id: 'charts.charts0Title',
    defaultMessage: 'Microservices benefit development teams',
  },
  charts1Title: {
    id: 'charts.charts1Title',
    defaultMessage: 'Microservices create better collaboration',
  },
  charts2Title: {
    id: 'charts.charts2Title',
    defaultMessage: 'Microservices help attract talent',
  },
  charts3Title: {
    id: 'charts.charts3Title',
    defaultMessage: 'The effort and expense of microservices is worth it',
  },
  charts4Title: {
    id: 'charts.charts4Title',
    defaultMessage: 'Microservices are a time-tested model for app development',
  },
  charts5Title: {
    id: 'charts.charts5Title',
    defaultMessage: 'Microservices help the bottom line',
  },
  charts6Title: {
    id: 'charts.charts6Title',
    defaultMessage: 'Microservices transformation is complex',
  },
  charts7Title: {
    id: 'charts.charts7Title',
    defaultMessage: 'The place of microservices innovation is challenging',
  },
  charts8Title: {
    id: 'charts.charts8Title',
    defaultMessage: 'Implementation seems overwhelming',
  },
});
